import { useState, useEffect } from 'react'

export function useCameraPermission() {
  const [permissionState, setPermissionState] = useState<PermissionState | null>(null)

  useEffect(() => {
    navigator.permissions?.query({ name: 'camera' as PermissionName })
      .then((result) => {
        setPermissionState(result.state)
        result.onchange = () => {
          setPermissionState(result.state)
        }
      })
      .catch(() => {
        // Permissions API not supported, assume we need to prompt
        setPermissionState('prompt')
      })
  }, [])

  return {
    permissionState,
    isGranted: permissionState === 'granted',
    isDenied: permissionState === 'denied',
    needsPrompt: permissionState === 'prompt',
    isLoading: permissionState === null
  }
}